import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./performanceApiClient";

export const getPerformanceTemplates = async (params = {}) =>
  getRequest("/templates", { params });

export const getPerformanceTemplate = async (templateId) =>
  getRequest(`/templates/${templateId}`);

export const createPerformanceTemplate = async (payload) =>
  postRequest("/templates", payload);

export const updatePerformanceTemplate = async (templateId, payload) =>
  putRequest(`/templates/${templateId}`, payload);

export const validatePerformanceTemplate = async (templateId) =>
  getRequest(`/templates/${templateId}/validate`);

export const getPerformanceTemplateSectionSourcePreview = async (
  templateId,
  sectionId,
) => getRequest(`/templates/${templateId}/sections/${sectionId}/source-preview`);

export const publishPerformanceTemplate = async (templateId) =>
  postRequest(`/templates/${templateId}/publish`, {});

export const clonePerformanceTemplate = async (templateId, payload = {}) =>
  postRequest(`/templates/${templateId}/clone`, payload);

export const archivePerformanceTemplate = async (templateId) =>
  postRequest(`/templates/${templateId}/archive`, {});

export const getPerformanceTemplateVersions = async (templateId, params = {}) =>
  getRequest(`/templates/${templateId}/versions`, { params });

export const getPerformanceTemplateVersion = async (templateId, version) =>
  getRequest(`/templates/${templateId}/versions/${version}`);

export const uploadPerformanceTemplateExcel = async (file) => {
  const body = new FormData();
  body.append("file", file);
  return postRequest("/templates/import", body, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const getPerformanceTemplateImport = async (importId) =>
  getRequest(`/templates/import/${importId}`);

export const validatePerformanceTemplateImport = async (importId) =>
  postRequest(`/templates/import/${importId}/validate`, {});

export const updatePerformanceTemplateImportMapping = async (
  importId,
  fieldMapping,
) => putRequest(`/templates/import/${importId}/mapping`, { fieldMapping });

export const confirmPerformanceTemplateImport = async (importId, payload = {}) =>
  postRequest(`/templates/import/${importId}/confirm`, payload);

export const deletePerformanceTemplateImport = async (importId) =>
  deleteRequest(`/templates/import/${importId}`);

export default {
  getPerformanceTemplates,
  getPerformanceTemplate,
  createPerformanceTemplate,
  updatePerformanceTemplate,
  validatePerformanceTemplate,
  getPerformanceTemplateSectionSourcePreview,
  publishPerformanceTemplate,
  clonePerformanceTemplate,
  archivePerformanceTemplate,
  getPerformanceTemplateVersions,
  getPerformanceTemplateVersion,
  uploadPerformanceTemplateExcel,
  getPerformanceTemplateImport,
  validatePerformanceTemplateImport,
  updatePerformanceTemplateImportMapping,
  confirmPerformanceTemplateImport,
  deletePerformanceTemplateImport,
};
